import React, { Component } from 'react';
import './calculadoraled.css';

export default class CalculadoraLed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Voltagem: 0,
      ResistenciaIdeal: 125,
    }
    this.Ideal = this.Ideal.bind(this);
  }
  IdealVerde(Voltagem) {
    if (Voltagem === 2.5) {
      return "Não Requer Resistor."
    } else
      if (Voltagem !== 0 && Voltagem) {
        let maxi = (Voltagem - 2.5) / 0.02;
        if (maxi <= 0) {
          return "Não possui voltagem suficiente.";
        }
        if (maxi > 1000) {
          maxi /= 1000;
          return maxi + " kΩ"
        } else {
          return maxi + " Ω";
        }
      } else {
        return 0 + " Ω";
      }
  }
  IdealAB(Voltagem) {
    if (Voltagem === 3) {
      return "Não Requer Resistor."
    } else
      if (Voltagem !== 0 && Voltagem) {
        let maxi = (Voltagem - 3) / 0.02;
        if (maxi <= 0) {
          return "Não possui voltagem suficiente.";
        }
        if (maxi > 1000) {
          maxi /= 1000;
          return maxi + " kΩ"
        } else {
          return maxi + " Ω";
        }
      } else {
        return 0 + " Ω";
      }
  }
  Ideal(Voltagem) {
    if (Voltagem === 2) {
      return "Não Requer Resistor."
    } else
      if (Voltagem !== 0 && Voltagem) {
        let maxi = (Voltagem - 2) / 0.02;
        if (maxi <= 0) {
          return "Não possui voltagem suficiente.";
        }
        if (maxi > 1000) {
          maxi /= 1000;
          return maxi + " kΩ"
        } else {
          return maxi + " Ω";
        }
      } else {
        return 0 + " Ω";
      }
  }
  render() {
    return (
      <div className="calcuLed">
        <h1> Insira o Valor da voltagem da sua fonte</h1>
        <input type="number" className="TextBox" onChange={(event) => { this.setState({ Voltagem: event.target.value }) }} />
        <h2>{this.state.Voltagem} Volts</h2>
        <h3 className="LVermelho">Led Vermelho: {this.Ideal(parseFloat(this.state.Voltagem))}</h3>
        <h3 className="LAmarelo">Led Amarelo: {this.Ideal(parseFloat(this.state.Voltagem))}</h3>
        <h3 className="LLaranja">Led Laranja: {this.Ideal(parseFloat(this.state.Voltagem))}</h3>
        <h3 className="LVerde">Led Verde: {this.IdealVerde(parseFloat(this.state.Voltagem))}</h3>
        <h3 className="LAzul">Led Azul: {this.IdealAB(parseFloat(this.state.Voltagem))}</h3>
        <h3 className="LBranco">Led Branco: {this.IdealAB(parseFloat(this.state.Voltagem))}</h3>
      </div>
    );
  }
}
